export default (travels, expenses, truckFilter) => {
  var trucks = {};
  var categoriesAmount = {};
  var suppliersAmount = {};
  var amountTravels = 0;
  var amountExpenses = 0;
  var amountKilometers = 0;

  for(let indexTravel = 0; indexTravel < travels.length; indexTravel++) {
    const { plate, amount_ton, quantity_ton, kilometer_initial, kilometer_final } = travels[indexTravel];

    if(truckFilter !== 'all' && truckFilter !== plate)
      continue;


    amountTravels += amount_ton * quantity_ton;

    if(!trucks[plate]){
      trucks[plate] = {
        plate,
        amount: 0,
        expense: 0,
        kilometer_min: 0,
        kilometer_max: 0
      }
    }

    trucks[plate]['amount'] += amount_ton * quantity_ton;
    trucks[plate]['kilometer_min'] = Math.min(trucks[plate]['kilometer_min'], kilometer_initial);
    trucks[plate]['kilometer_max'] = Math.max(trucks[plate]['kilometer_max'], kilometer_final);
    amountKilometers += kilometer_final- kilometer_initial;
  }

  for(let indexExpenses = 0; indexExpenses < expenses.length; indexExpenses++){
    const { amount, plate, categorydescription, category, supplier, suppliername } = expenses[indexExpenses];
    if(truckFilter !== 'all' && truckFilter !== plate)
      continue;

    amountExpenses += amount;

    if(plate){
      if(!trucks[plate]){
        trucks[plate] = {
          plate,
          amount: 0,
          expense: 0,
          kilometer_min: 0,
          kilometer_max: 0
        }
      }
      trucks[plate]['expense'] += amount;
    }

    if(category){
      if(!categoriesAmount[categorydescription])
        categoriesAmount[categorydescription] = {
          amount: 0,
          name: categorydescription
        };

      categoriesAmount[categorydescription]['amount'] += amount;
    }

    if(supplier){
      if(!suppliersAmount[suppliername])
        suppliersAmount[suppliername] = {
          amount: 0,
          name: suppliername
        };

      suppliersAmount[suppliername]['amount'] += amount;
    }

  }

  return {
    trucks: Object.values(trucks),
    amountTravels,
    amountKilometers,
    amountExpenses,
    categories: Object.values(categoriesAmount),
    suppliers: Object.values(suppliersAmount),
    totalTravels: travels.length
  };
}
